export default __webpack_public_path__ + "static/media/placeholder_empty_classroom.4c65e9c3.png";